import Modal from '../modal';

import './styles.css';
import Logo from '../images/logo.jpg';

export const Step1ReviewSession = ({onNext}) => {
  return (
    <Modal className="step-1">
      <img src={Logo} alt="Logo" className="onboarding-logo" />
      <h1>Welcome to Reviews Sessions!</h1>
      <h2>Let’s get your class all set up!</h2>
      <button className="button onboarding-big-button" onClick={onNext}>Get Started</button>
    </Modal>
  )
};